/**********************************************************************
 ** dms Routes                                                   **
 **********************************************************************/

(function () {
  'use strict';

  angular
    .module('home')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // forms menu
      $stateProvider.state('forms', {
        url: '/forms',
        abstract: true,
        views: {
          'main': {
            template: `
              <div ui-view="formsmain"></div>
              <div ui-view="f2"></div>
              <div ui-view="f3"></div>
              <div ui-view="f4"></div>
              <div ui-view="f5"></div>
            `
          }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('forms state entered, params: ', $state.params);
        }]
      });

      $stateProvider
        .state('forms.aide', {
          url: '/aide',
          views: {
            formsmain: {
              component: 'newaide',
              bindings: {}
            }
          },
          resolve: {},
          onEnter: ['$state', function onEnter($state) {
            console.log('forms.aide state entered, params: ', $state.params);
          }]

        });

      $stateProvider
        .state('forms.referral', {
          url: '/referral',
          views: {
            formsmain: {
              component: 'newref',
              bindings: {}
            }
          },
          resolve: {},
          onEnter: ['$state', function onEnter($state) {
            console.log('forms.referral state entered, params: ', $state.params);
          }]
        });


      $stateProvider
        .state('forms.time', {
          url: '/time',
          views: {
            formsmain: {
              component: 'timeslip',
              bindings: {}
            }
          },
          resolve: {},
          onEnter: ['$state', function onEnter($state) {
            console.log('forms.time state entered, params: ', $state.params);
          }]
        });


      $stateProvider
        .state('forms.textprocessing', {
          url: '/textprocessing',
          views: {
            formsmain: {
              component: 'textprocessing',
              bindings: {}
            }
          },
          resolve: {},
          onEnter: ['$state', function onEnter($state) {
            console.log('forms.textprocessing state entered, params: ', $state.params);
          }]
        });


    }

// klammerfriedhof
  }
}());